module.exports = __webpack_public_path__ + "4360818a785d6d3c6e2c89d8cbd902c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/thomas_broennimann.png
// module id = 126
// module chunks = 0